import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import _ from 'lodash';
import RFSInfo from 'Work-Orders/Components/RFSInfo';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { AppSettings } from '../../constants';
import * as RFSActionType from '../constants';
import * as WorkOrderActionType from 'Work-Orders/constants';
import TableList from 'components/TableList';
import SignoffMultiplePopup from '../Components/SignoffMultiplePopup';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import ReviewRFS from '../Components/ReviewRFS';
import { print } from '../../helper/unit-helper';
import {
  renderAgeOfWorkOrder,
  checkIsOverdueWorkOrder,
  formatTimezoneDateTime,
  toggleScrollBody
} from 'helper/unit-helper';
import { CheckBox } from 'components/checkboxes/check-box';
import { Popup } from 'components/Popup/popup';
import { Modal } from "react-bootstrap";
import ConfirmModal from "../../components/ConfirmModal";
import { bindActionCreators } from "redux";
import componentActions from "../../components/actions";
import ReassignWO from '../Components/ReassignWO';
import * as PunchListActionTypes from '../../Punch-List/constants';
import * as ProjectActionType from '../../Projects/constants';
import * as WOTActionType from '../../Work-Order-Type/constants';
import * as TradeActionType from '../../Trades/constants';
import OpenAwaitPopup from '../../Work-Orders/Components/OpenAwaitPopup';
import * as LotActionType from '../../Lots/constants';
import * as SubcontractorActionType from '../../Subcontractors/constants';
import * as ItemActionType from '../../Items/constants';
import SendMultipleWorkOrderPopup from '../../Punch-List/Components/SendMultipleWorkOrderPopup';

const defaultParams = {
  defaultSortName: 'refNo',
  defaultSortOrder: 'descending',
  sizePerPage: 100
};

let defaultFilter =
  AppSettings.clientTypeValue !== 'Homeowner' ? [0,1,2,6] // Open, Pending, Request
    : AppSettings.WO_STATUS_VALUE.map(item => item.key);

let WOSelectedInformation = null

class RFSDetail extends Component {
  static propTypes = {
    history: PropTypes.object,
    ManageWorkOrderTypes: PropTypes.object,
    dispatch: PropTypes.func,
    match: PropTypes.object,
    location: PropTypes.object,
    WorkOrders: PropTypes.object,
    rfsAction: PropTypes.object,
    ManagerStore: PropTypes.object,
    LotStore: PropTypes.object,
    SubcontractorList: PropTypes.any,
    UserList: PropTypes.any,
    WorkOrderTypeList: PropTypes.any,
    TradeList: PropTypes.any,
    ItemRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
  };
  constructor(props) {
    super(props);

    let rfsId = null;

    if (props.match.params.RFSID) {
      rfsId = props.match.params.RFSID;
    }

    const queryParams = new URLSearchParams(this.props.location.search);
    let modeClose = false;
    if (queryParams.get("mode") && queryParams.get("mode") === "close") {
      modeClose = true;
    }

    const headerOptions = [
      {
        value: 0,
        text: "Bulk actions",
      },
      {
        value: 1,
        text: "Close multiple WOs",
      },
      {
        value: 2,
        text: "Reassign",
      },
      {
        value: 3,
        text: "Send multiple WOs",
      },
    ];

    this.state = {
      requireFormField: [],
      rfsStatus: AppSettings.RFS_STATUS_VALUE,
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      data: [],
      sizePerPage: defaultParams.sizePerPage,
      rfsId: rfsId,
      modeClose: modeClose,
      headerOptions: headerOptions,
      headerAction: modeClose ? headerOptions[1] : headerOptions[0],
      isDisplaySignoffMultiplePopup: false,
      // OpenAccordion: true,
      column: [
        {
          field: "refNo",
          header: "WO#",
          hidden: false,
          isKey: true,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderWOID.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.Trade",
          header: "Trade",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderTrade.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.SubcontractorOfProject",
          header: "Assigned to",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderAssigned.bind(this),
          widthStyle: "name",
        },
        {
          field: "Summary",
          header: "Summary",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderSummary.bind(this),
          widthStyle: "address",
        },
        {
          field: "Description",
          header: "Description",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderDescription.bind(this),
          widthStyle: "address",
        },
        {
          field: "WOInformation.StatusValue",
          header: "Status",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderStatus.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.dueDate",
          header: "Age of assignment",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderAge.bind(this),
          widthStyle: "name",
        },
        {
          field: "name",
          header: "WOT",
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderWOT.bind(this),
          widthStyle: "name",
          apiField: "name",
        },
        {
          field: "WOInformation.SubcontractorOfProject",
          header: "Item to repair",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderItemtorepair.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.SubcontractorOfProject",
          header: "Problem",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderProblem.bind(this),
          widthStyle: "name",
        },
      ],
      refNoCheckList: {},
      isSetDefaultCheckList: false,
      isShowPopup: false,
      checkedValues: defaultFilter,
      openRFSSignoffConfirmModal: false,
      isRFSWithOpenWO: false,
      isDisplayReassignWOComponent: false,
      openReassignModal: false,
      refNoCheckListForReassign: {},
      rfsRefNoList: [],
      selectAllWO: false,
      reassignComponentData: [],
      disableSelectAll: false,
      isWOChecked : false,
      isAllSelectedWO:false,
      refNoSendCheckList: {},
      isDisplaySendMultiplePopup: false,
      WoSelectedList: [],
      ConfirmSendMultiple: false,
    };
    this.defaultNumOfColumn = this.state.column.length;
    this.checkBoxRender = this.checkBoxRender.bind(this);
  }

  componentDidMount() {
    this.fetchDetailRfs();

    if (this.state.modeClose) {
      this.onApplyAction(this.state.headerAction.value, this.props);
    }

    const self = this;
    window.addEventListener("click", (e) => {
      if (
        document.getElementById("s1-popup") &&
        document.getElementById("s1-popup").contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById("popup-button") &&
          document.getElementById("popup-button").contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const { WorkOrders } = nextProps;

    if (!isEmpty(WorkOrders.WorkOrders)) {
      this.setState({
        workOrders: WorkOrders.WorkOrders,
      });
    }

    if (this.state.modeClose && !this.state.isSetDefaultCheckList) {
      this.handleCheckBoxList(nextProps);
    }
    // if (this.state.isDisplayReassignWOComponent) {
    //   this.handleCheckBoxListForReassign(nextProps);
    // }
    if (
      nextProps.ManagerStore.RFSProfile &&
      nextProps.ManagerStore.RFSProfile.workOrders &&
      nextProps.ManagerStore.RFSProfile.workOrders.items
    ) {
      let items = [...nextProps.ManagerStore.RFSProfile.workOrders.items];
      if(items.length == 0){
        this.setState({disableSelectAll: true})
      }else{
        this.setState({disableSelectAll: false})
      }

      const { checkedValues, defaultSortName, defaultSortOrder } = this.state;

      items = items.filter((item) => checkedValues.includes(item.status));

      items = this.handleSorting(items, defaultSortName, defaultSortOrder);

      this.setState({ data: items });
    }
  }

  fetchDetailRfs() {
    this.props.dispatch({
      type: RFSActionType.GET_BY_RFS_ID_ASYNC,
      params: this.state.rfsId,
      callback: (rfsDetail) => {
        this.isWorkOrderStatus(rfsDetail);
      },
      onError: () => {
        this.props.dispatch({
          type: RFSActionType.GET_BY_RFS_ID_ASYNC,
          params: this.state.rfsId,
          callback: (rfsDetail) => {
            this.isWorkOrderStatus(rfsDetail);
          },
        });
      },
    });
  }

  onSaveSendMultiple = (params) => {

    this.props.dispatch({
      type: WorkOrderActionType.BULK_UPDATE_MULTIPLE_WO_ASYNC,
      params: params,
      callback: () => {
        this.setState({
          isDisplaySendMultiplePopup: false,
          WoSelectedList: [],
          requireFormField: [],
          headerAction: {
            value: 0,
            text: 'Bulk actions'
          }
        })

        toggleScrollBody(true);

        const newColumnState = [...this.state.column];
        newColumnState.shift();
        this.setState({
          column: newColumnState,
          refNoSendCheckList: {},
        });
        this.fetchDetailRfs();
      }
    });
  };
  
  onTogglePopup = type => () => {
    const requireFormField = [];

    const WOs = this.props.ManagerStore.RFSProfile.workOrders.items
    const filtered = []

    this.state.WoSelectedList.map((id)=> {
      filtered.push(WOs.find((wo)=> wo.refNo == id ))
    })

    filtered.map((wo)=>{
     
        if (!wo.workOrderType && !requireFormField.includes('workOrderType')) {
          requireFormField.push('workOrderType');
        }
        if (!wo.trade && !requireFormField.includes('trade')) {
          requireFormField.push('trade');
          if(!requireFormField.includes('assigned')){
            requireFormField.push('assigned');
          }
          if(!requireFormField.includes('itemRepair')){
            requireFormField.push('itemRepair');
          }
          if(!requireFormField.includes('problem')){
            requireFormField.push('problem');
          }
        }
        if (!wo.subcontractorProfile && !wo.assignedUser && !requireFormField.includes('assigned')) {
          requireFormField.push('assigned');
        }
        if (!wo.itemToRepair && !requireFormField.includes('itemRepair')) {
          if(!requireFormField.includes('trade')){
            requireFormField.push('trade');
          }
          requireFormField.push('itemRepair'); 
        }
        if (!wo.problem && !requireFormField.includes('problem')) {
          requireFormField.push('problem');
        }
    })
    
    if(requireFormField.length > 0){
      this.setState({
        requireFormField: requireFormField,
        isDisplaySendMultiplePopup: true
      });
    }else{
      this.setState({
        requireFormField: [],
        ConfirmSendMultiple: true
      });
    }
  };

  onClickSubmitOpenPend = (type, values) => {
    const WOs = this.props.ManagerStore.RFSProfile.workOrders.items
    const filtered = []
    const WOJson = []

    this.state.WoSelectedList.map((id)=> {
      filtered.push(WOs.find((wo)=> wo.refNo == id ))
    })
    
    if(filtered.length > 0){  
      filtered.map((wo)=>{
        const WorkOrder = {
          "tradeId": wo.trade ? wo.trade.id: values.tradeId, 
          "itemToRepairId": wo.itemToRepair ? wo.itemToRepair.id : values.itemToRepairId, 
          "problemId": wo.problem ? wo.problem.id : values.problemId,
          "subcontractorId": wo.subcontractorProfile ? wo.subcontractorProfile.subcontractorId : wo.assignedUser ? null : values.subcontractorId,
          "assignedUserId": wo.assignedUser ? wo.assignedUser.id : wo.subcontractorProfile ? null : values.assignedUserId,
          "workOrderTypeId": wo.workOrderType ? wo.workOrderType.id : values.workOrderTypeId,
          "status": "Open",
          "WONo": wo.refNo
        }
      WOJson.push(WorkOrder)
      })
    }
    
    let params = {
      "RefNos": [this.props.ManagerStore.RFSProfile.refNo],
      "BulkUpdateMultipleWorkOrderDto": WOJson
    }

    this.onSaveSendMultiple(params)
  };

  onClickGoSendMultiplePopup = () => {
    this.setState({
      ConfirmSendMultiple: !this.state.ConfirmSendMultiple
    });
  };

  onClickpopupSendMultiple = () => {
    this.setState({
      isDisplaySendMultiplePopup: !this.state.isDisplaySendMultiplePopup
    });
  };

  isWorkOrderStatus = (rfsDetail) => {
    if (rfsDetail.workOrders) {
      const workOrders = rfsDetail.workOrders.items;
      if (workOrders !== undefined && workOrders.length > 0) {
        const openWOCount = workOrders.findIndex(
          (wo) => wo.status !== 4 && wo.status !== 5
        );
        this.setState({ isRFSWithOpenWO: openWOCount === -1 });
      } else {
        this.setState({ isRFSWithOpenWO: true });
      }
      this.setState({ isRFSWithNoWO: !workOrders.length });
    }
  };

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter((item) => item !== value),
          ],
        },
        () => {
          this.onCheckedFilterStatus(e, this.state.checkedValues);
        }
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value],
        },
        () => {
          this.onCheckedFilterStatus(e, this.state.checkedValues);
        }
      );
    }
  };

  onCheckedFilterStatus = () => {
    const { items } = this.props.ManagerStore.RFSProfile.workOrders;
    if (items) {
      this.onFilterWorkOrder(items);
    }
  };

  onFilterWorkOrder = (paramItems) => {
    let items = [...paramItems];
    const { checkedValues, defaultSortName, defaultSortOrder } = this.state;

    items = items.filter((item) => checkedValues.includes(item.status));

    items = this.handleSorting(items, defaultSortName, defaultSortOrder);

    this.setState({ data: items });
  };

  onChangeStatus(event) {
    this.setState((prevState) => ({
      RFSInforamation: {
        ...prevState.RFSInforamation,
        status: event.value,
      },
    }));
  }

  toolTipEOC() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>Electronic Signature Form</span>
      </Tooltip>
    );
  }

  refreshList(params) {
    const { defaultSortName, defaultSortOrder, sizePerPage } = params;

    this.setState(
      {
        defaultSortName,
        defaultSortOrder,
        sizePerPage,
      },
      () => {
        let currentData = [...this.state.data];

        currentData = this.handleSorting(
          currentData,
          defaultSortName,
          defaultSortOrder
        );

        this.setState({ data: currentData });
      }
    );
  }

  handleSorting = (items, sortName, sortOder) => {
    const order = sortOder === "ascending" ? "asc" : "desc";

    const results = _.orderBy(items, sortName, order);

    return results;
  };

  fetchUser = () => {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_USER_ASYNC,
      params: {
        projectId: this.props.ManagerStore.RFSProfile.project.id
      },
      callback: () => {
        this.setState({ isFetchedUser: true });
      }
    });
  };

  onFetchWorkOrderType = () => {
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      }
    });
  };

  fetchTrade = () => {
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      }
    });
  };

  fetchItemRepair = tradeId => {
    this.props.dispatch({
      type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
      params: {
        id: tradeId,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      }
    });
  };

  fetchProblem = itemToRepairId => {
    this.props.dispatch({
      type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
      params: {
        id: itemToRepairId,
        searchKey: ''
      }
    });
  };

  fetchSubcontractor = tradeId => {
    this.props.dispatch({
      type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
      params: {
        projectId: this.props.ManagerStore.RFSProfile.project.id,
        lotId: this.props.ManagerStore.RFSProfile.lot.id,
        tradeId: tradeId,
        param: {
          searchKey: '',
          selectedValue: ''
        }
      },
      callback: () => {
        this.setState({ isFetchedSubcontractor: true });
      }
    });
  };

  customRenderWO = (field, row) => {
    let value = get(row, field);
    return value || "";
  };

  onClickWOID = (item) => (e) => {
    e.preventDefault();
    this.props.dispatch({
      type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_SUCCESS,
      data: {
        workOrder: item,
        requestDetail: this.props.ManagerStore.RFSProfile,
      },
    });
    this.props.history.push(
      `/request-for-services/work-order/detail/${this.state.rfsId}/${item.refNo}`
    );
  };

  onNewWorkOrder = () => {
    this.props.history.push(
      `/request-for-services/work-order/add/${this.state.rfsId}`
    );
  };

  onEOCList = () => {
    var rfsDetail = this.props.ManagerStore.RFSProfile;
    if (
      rfsDetail.esfTemplateStatus === "False" ||
      rfsDetail.esfTemplateStatus === false
    ) {
      this.props.toggleModal({
        modalName: ConfirmModal.MODAL_NAME,
        modalProps: {
          message:
            "ESF template not found \n Please contact your administrator!",
          title: "ESF Form",
          hideCancel: true,
          okText: "Ok",
          okClass: "btn btn-primary btn-siteone",
          show: true,
          okFunc: () => {
            this.props.toggleModal({ modalName: "", ActiveModal: null });
          },
        },
        ActiveModal: ConfirmModal,
      });
      return true;
    } else if (rfsDetail.esfStatus === "True" || rfsDetail.esfStatus === true) {
      this.props.history.push(
        `/request-for-services/electronic-orientation-checklists/${this.state.rfsId}`
      );
    } else if (this.state.isRFSWithNoWO) {
      this.props.toggleModal({
        modalName: ConfirmModal.MODAL_NAME,
        modalProps: {
          message: `Since there is no work order to close we cannot sign-off the RFS.`,
          title: "No work order in the RFS",
          hideCancel: true,
          okText: "Ok",
          okClass: "btn btn-primary btn-siteone",
          show: true,
          okFunc: () => {
            this.props.toggleModal({ modalName: "", ActiveModal: null });
          },
        },
        ActiveModal: ConfirmModal,
      });
      return true;
    } else if (
      this.state.isRFSWithOpenWO &&
      this.props.ManagerStore.RFSProfile.status !== 3
    ) {
      this.props.history.push(
        `/request-for-services/electronic-orientation-checklists/${this.state.rfsId}`
      );
    } else if (rfsDetail.status === 3) {
      this.props.history.push(
        `/request-for-services/electronic-orientation-checklists/${this.state.rfsId}`
      );
    } else {
      this.setState({ openRFSSignoffConfirmModal: true });
    }
  };

  goToESFForm = () => {
    this.props.history.push(
      `/request-for-services/electronic-orientation-checklists/${this.state.rfsId}`
    );
  };

  onCancel = () => {
    this.setState({ openRFSSignoffConfirmModal: false });
  };
  proceedToSignoff = () => {
    this.setState({ openRFSSignoffConfirmModal: false });
  };
  rfsRestrictModal = () => {
    return (
      <Modal
        dialogClassName="confirm-cancel-save-eoc-template-dialog"
        show={this.state.openRFSSignoffConfirmModal}
        centered="true"
        size="sm"
      >
        <Modal.Header>
          <Modal.Title>ESF form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>
            It seems the WO are not resolved or closed. Please try refreshing
            the page or try contacting your Admin!
          </span>
        </Modal.Body>
        <Modal.Footer>
          <div className="suspend-group-btn" style={{ float: "left" }}>
            {/* <button
              className="btn btn-primary btn-siteone-default"
              onClick={this.onCancel}
            >
              Cancel
            </button> */}
            <button
              style={{ marginLeft: 10 }}
              className="btn btn-primary btn-siteone"
              onClick={this.proceedToSignoff}
            >
              Ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };
  handleCheckBoxList = (props) => {
    if (
      props.ManagerStore.RFSProfile &&
      props.ManagerStore.RFSProfile.workOrders &&
      props.ManagerStore.RFSProfile.workOrders.items &&
      props.ManagerStore.RFSProfile.workOrders.items.length
    ) {
      const { items } = props.ManagerStore.RFSProfile.workOrders;
      const checkedList = {};
      for (let i = 0; i < items.length; i++) {
        if (AppSettings.clientTypeValue === "Homeowner") {
          if (items[i].status === 4) {
            checkedList[items[i].refNo] = true;
          }
        } else {
          if (items[i].status === 1 || items[i].status === 4) {
            checkedList[items[i].refNo] = true;
          }
        }
      }
      this.setState({
        refNoCheckList: checkedList,
        isSetDefaultCheckList: true,
      });
    }
  };

  onApplyAction = (value, props) => {
    const { column, data } = this.state;
    if (value === 1) {
      const checkboxColumn = {
        field: "",
        header: "",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
        columnClassName: "td-width-50-px",
        customRender: this.customRenderCheckboxColumn.bind(this),
      };
      const newColumnState = [...column];
      if (column.length > this.defaultNumOfColumn) {
        newColumnState.shift();
      }
      newColumnState.unshift(checkboxColumn);
      this.setState({
        column: newColumnState,
      });
      this.handleCheckBoxList(props);
    } else if(value === 3){
      this.setState({WoSelectedList: []})
      this.onActionSendMultiple(props);
    }else if (value !== 2) {
      const newColumnState = [...column];
      newColumnState.shift();
      this.setState({
        column: newColumnState,
      });
    }     else{
    const updatedWOs = data.map(item => ({
        ...item,
        isWOSelected: false
    }));
      this.setState({
        refNoCheckListForReassign: {},
        data:updatedWOs,
      },()=>{
        this.onApplyActionReassign(props);
      });
    }
  };

  onApplyActionReassign = (props) => {
    const { column } = this.state;
    const checkboxColumn = {
      field: "",
      header: this.checkBoxRender(),
      hidden: false,
      isKey: false,
      sort: false,
      dataAlign: "left",
      headerAlign: "left",
      columnClassName: "td-width-50-px",
      customRender: this.customRenderCheckboxColumnReassign.bind(this),
    };
    const newColumnState = [...column];
    if (column.length > this.defaultNumOfColumn) {
      newColumnState.shift();
      this.setState({
        column: newColumnState,
      });
    }

    newColumnState.unshift(checkboxColumn);
    this.setState({
      column: newColumnState,
      // reassignComponentData: [],
      refNoCheckListForReassign: {},
    });
  };

  onChangeHeaderAction = (event) => {
    this.setState({
      headerAction: event.value,
    });
    this.onApplyAction(event.value.value, this.props);
  };

  onChecked = (refNo) => {
    if (!this.state.refNoCheckList[refNo]) {
      this.setState({
        refNoCheckList: {
          ...this.state.refNoCheckList,
          [refNo]: !this.state.refNoCheckList[refNo],
        },
      });
    } else {
      let newCheckList = { ...this.state.refNoCheckList };
      delete newCheckList[refNo];
      this.setState({
        refNoCheckList: newCheckList,
      });
    }
  };

  onCheckedSendAction = refNo => {   
    const { refNoSendCheckList } = this.state;
    const checkID = this.state.WoSelectedList.indexOf(refNo)

    if (checkID == -1) {
      this.state.WoSelectedList.push(refNo)
    }else {
      this.setState({ WoSelectedList: this.state.WoSelectedList.filter((it) => it !== refNo) });
    }

    if (!refNoSendCheckList[refNo]) {
      this.setState({
        refNoSendCheckList: {
          ...refNoSendCheckList,
          [refNo]: !refNoSendCheckList[refNo]
        }
      });
    } else {
      let newCheckList = { ...refNoSendCheckList };
      delete newCheckList[refNo];
      this.setState({
        refNoSendCheckList: newCheckList
      });
    }
  };

  toolTipDisabledSend() {
    return (
      <Tooltip
        id='sign_off_multiple_work_order_tooltip'
        className='in tooltip-siteone'
      >
        <span>Only work orders with Pending and Awaiting review status can be selected.</span>
      </Tooltip>
    );
  }

  customRenderCheckboxColumnSend(item) {
    const { status, refNo } = item;
    const { refNoSendCheckList } = this.state;
    const disabled = status !== 2 && status !== 0; //status !== pending => disabled checkbox
    if (disabled) {
      return (
        <OverlayTrigger placement='top' overlay={this.toolTipDisabledSend()}>
          <div>
            <CheckBoxSingle
              checked={
                refNoSendCheckList[refNo] !== null &&
                refNoSendCheckList[refNo] === true
              }
              ref={c => {
                this.check = c;
              }}
              name='checkToSend'
              disabled={disabled}
              className='checkbox-default'
              onChecked={() => this.onCheckedSendAction(refNo)}
              style={{ marginTop: -7 }}
            />
          </div>
        </OverlayTrigger>
      );
    } else {
      return (
        <CheckBoxSingle
          checked={
            refNoSendCheckList[refNo] !== null &&
            refNoSendCheckList[refNo] === true
          }
          ref={c => {
            this.check = c;
          }}
          name='checkToSend'
          disabled={disabled}
          className='checkbox-default'
          onChecked={() => this.onCheckedSendAction(refNo)}
          style={{ marginTop: -7 }}
        />
      );
    }
  }

  // onCheckedForReassign = (refNo) => {
  //   this.setState({
  //     selectAllWO:false
  //   },()=>{
  //     this.checkBoxRender()
  //   });
    
  //   const findrefNo = this.state.reassignComponentData.find(
  //     (item) => item.refNo == refNo
  //   );
  //   console.log("findrefNo", findrefNo);

  //   if (findrefNo) {
  //     const filteredData = this.state.reassignComponentData.filter(
  //       (item) => item.refNo !== findrefNo.refNo
  //     );
  //     console.log("filteredData", filteredData);
  //     this.setState({ reassignComponentData: filteredData }, () => {
  //       let newCheckList = { ...this.state.refNoCheckListForReassign };
  //       console.log("newCheckList", newCheckList);
  //       delete newCheckList[refNo];
  //       this.setState(
  //         {
  //           refNoCheckListForReassign: newCheckList,
  //         },
  //         () => {
  //         }
  //       );
  //     });
  //   } else {
  //     const filteredArray = this.state.data.find(
  //       (item) => item.refNo === refNo
  //     );
  //     this.state.reassignComponentData.push(filteredArray);
  //     console.log(
  //       "this.state.reassignComponentData",
  //       this.state.reassignComponentData
  //     );
  //     this.setState(
  //       {
  //         refNoCheckListForReassign: {
  //           ...this.state.refNoCheckListForReassign,
  //           [refNo]: true,
  //         },
  //       },
  //       () => {
  //         console.log(
  //           "refNoCheckListForReassign",
  //           this.state.refNoCheckListForReassign
  //         );
  //       }
  //     );
  //   }
  // };

  onCheckedForReassign = (refNo) => {
    const { data } = this.state;
    const updatedWOs = data.map(item => {
      if (item.refNo === refNo) {
        return {
          ...item,
          isWOSelected: !item.isWOSelected
        };
      }
      return item; // Don't forget to return the unchanged items
    });
  
    this.setState({
      data: updatedWOs,
    },()=>{
      this.setState({isWOChecked:true})
      this.onApplyActionReassign()
    });
  }

  // onCheckedSelectAll = (value) => {
  //   console.log('value', value)
  //   const {
  //     data,
  //     refNoCheckListForReassign,
  //     selectAllWO,
  //     reassignComponentData,
  //   } = this.state;
  //   console.log("Data", data);
  //   let extractedRefNoChecklist = [];
  //   if (!selectAllWO) {
  //     this.setState({ selectAllWO: true, reassignComponentData: data }, () => {
  //       data.map((item) => {
  //         extractedRefNoChecklist.push({
  //           ...refNoCheckListForReassign,
  //           [item.refNo]: !refNoCheckListForReassign[item.refNo],
  //         });
  //       });
  //       let combinedObject = {};
  //       for (let key in extractedRefNoChecklist) {
  //         let innerObject = extractedRefNoChecklist[key];
  //         let innerKey = Object.keys(innerObject)[0];
  //         let innerValue = innerObject[innerKey];
  //         combinedObject[innerKey] = innerValue;
  //       }
  //       console.log("combinedObject", combinedObject);
  //       this.setState({
  //         refNoCheckListForReassign: combinedObject,
  //       });
  //     });
  //   } else {
  //     console.log("selectAllWO", selectAllWO, refNoCheckListForReassign);
  //     this.setState({
  //       selectAllWO: false,
  //       reassignComponentData: [],
  //       refNoCheckListForReassign: {},
  //     });
  //     // let newCheckList = { ...this.state.refNoCheckList };
  //     // delete newCheckList[refNo];
  //     // this.setState({
  //     //   refNoCheckList: newCheckList
  //     // });
  //   }
  // };

  onCheckedSelectAll =()=>{
    const{data, isAllSelectedWO} = this.state;

    const updatedWOs = data.map(item => ({
      ...item,
      isWOSelected: !isAllSelectedWO
  }));
  this.setState({
    data:updatedWOs
  },()=>{
    this.onApplyActionReassign();
  })
  }
  toolTip() {
    return (
      <Tooltip
        id="sign_off_multiple_work_order_tooltip"
        className="in tooltip-siteone"
      >
        <span>
          Only work orders with{" "}
          {AppSettings.clientTypeValue === "Homeowner"
            ? "Resolved"
            : "Open/Resolved"}{" "}
          status can be selected.
        </span>
      </Tooltip>
    );
  }

  popoverRight() {
    return (
      <Popover id="popover-positioned-right" className="sign-off-error-popover">
        <span>At least one work order must be selected.</span>
      </Popover>
    );
  }

  printPreviewRFS = () => {
    this.props.dispatch({
      type: RFSActionType.PRINT_PREVIEW_RFS_ASYNC,
      params: {
        refNo: this.state.rfsId,
      },
      callback: (status, content) => {
        if (status) {
          print(content);
        }
      },
    });
  };

  onClickGoSignoffMultiplePopup = () => {
    if (AppSettings.clientTypeValue !== "Homeowner") {
      this.setState({
        isDisplaySignoffMultiplePopup:
          !this.state.isDisplaySignoffMultiplePopup,
      });
    } else {
      this.onSaveSignoffMultiple(formatTimezoneDateTime(Moment()));
    }
  };

  onSaveSignoffMultiple = (lastClosedDate) => {
    const { refNoCheckList } = this.state;
    let workOrderIds = [];
    Object.keys(refNoCheckList).forEach((key) => {
      if (refNoCheckList[key]) {
        workOrderIds.push(parseInt(key));
      }
    });

    if (AppSettings.clientTypeValue === "Homeowner") {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileSignOffMultiple(workOrderIds, lastClosedDate);
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          (item) => item.lot.id === this.props.ManagerStore.RFSProfile.lot.id
        );
        if (lotFound) {
          this.onSignOffMultiHomeownerWorkOrder(
            lotFound.builderProfile,
            workOrderIds,
            lastClosedDate
          );
        } else {
          this.onGetBuilderProfileSignOffMultiple(workOrderIds, lastClosedDate);
        }
      }
    } else {
      this.props.dispatch({
        type: RFSActionType.SIGNOFF_MULTIPLE_WORK_ORDER_ASYNC,
        params: {
          refNo: this.state.rfsId,
          param: {
            workOrderIds,
            lastClosedDate,
          },
        },
        callback: () => {
          this.setState({
            isDisplaySignoffMultiplePopup: false,
            headerAction: {
              value: 0,
              text: "Bulk actions",
            },
          });
          const newColumnState = [...this.state.column];
          newColumnState.shift();
          this.setState({
            column: newColumnState,
          });
          this.fetchDetailRfs();
        },
      });
    }
  };

  onActionSendMultiple = props => {
    const { column } = this.state;
    const checkboxColumn = {
      field: '',
      header: '',
      hidden: false,
      isKey: false,
      sort: false,
      dataAlign: 'left',
      headerAlign: 'left',
      columnClassName: 'td-width-50-px',
      customRender: this.customRenderCheckboxColumnSend.bind(this)
    };

    const newColumnState = [...column];

    if (column.length > this.defaultNumOfColumn) {
      newColumnState.shift();
    }

    newColumnState.unshift(checkboxColumn);
    this.setState({
      column: newColumnState,
    });

    this.handleCheckBoxListSend(props);
  };

  handleCheckBoxListSend = () => {
    if (this.state.data.length) {
      const { data } = this.state;
      const checkedList = {};
  
      this.setState({
        refNoSendCheckList: checkedList
      });
    }
  };

  onGetBuilderProfileSignOffMultiple = (workOrderIds, lastClosedDate) => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: this.props.ManagerStore.RFSProfile.lot.id,
      },
      callbackGetBuilderProfile: (builderProfile) => {
        this.onSignOffMultiHomeownerWorkOrder(
          builderProfile,
          workOrderIds,
          lastClosedDate
        );
      },
    });
  };

  onSignOffMultiHomeownerWorkOrder = (
    builderProfile,
    workOrderIds,
    lastClosedDate
  ) => {
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: RFSActionType.SIGNOFF_MULTIPLE_HOMEOWNER_WORK_ORDER_ASYNC,
      params: {
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken,
        },
        param: {
          refNo: this.state.rfsId,
          data: {
            workOrderIds,
            lastClosedDate,
          },
        },
      },
      callback: () => {
        this.setState({
          isDisplaySignoffMultiplePopup: false,
          headerAction: {
            value: 0,
            text: "Bulk actions",
          },
        });
        const newColumnState = [...this.state.column];
        newColumnState.shift();
        this.setState({
          column: newColumnState,
        });
        this.fetchDetailRfs();
      },
    });
  };

  onChecked = refNo => {
    if (!this.state.refNoCheckList[refNo]) {
      this.setState({
        refNoCheckList: {
          ...this.state.refNoCheckList,
          [refNo]: !this.state.refNoCheckList[refNo]
        }
      });
    } else {
      let newCheckList = { ...this.state.refNoCheckList };
      delete newCheckList[refNo];
      this.setState({
        refNoCheckList: newCheckList
      });
    }
  };

  customRenderCheckboxColumn(item) {
    const { status, refNo } = item;
    const disabled =
      (AppSettings.clientTypeValue === "Homeowner" && status !== 4) ||
      (AppSettings.clientTypeValue !== "Homeowner" &&
        status !== 1 &&
        status !== 4);
    if (disabled) {
      return (
        <OverlayTrigger placement="top" overlay={this.toolTip()}>
          <div>
            <CheckBoxSingle
              checked={
                this.state.refNoCheckList[refNo] !== null &&
                this.state.refNoCheckList[refNo] === true
              }
              ref={(c) => {
                this.check = c;
              }}
              name="checkToSignoff"
              disabled={disabled}
              className="checkbox-default"
              onChecked={() => this.onChecked(refNo)}
              style={{ marginTop: -7 }}
            />
          </div>
        </OverlayTrigger>
      );
    } else {
      return (
        <CheckBoxSingle
          checked={
            this.state.refNoCheckList[refNo] !== null &&
            this.state.refNoCheckList[refNo] === true
          }
          ref={(c) => {
            this.check = c;
          }}
          name="checkToSignoff"
          disabled={disabled}
          className="checkbox-default"
          onChecked={() => this.onChecked(refNo)}
          style={{ marginTop: -7 }}
        />
      );
    }
  }

  customRenderCheckboxColumnReassign(item) {
    const { refNo } = item;
    const{data}=this.state;
    let isWO = data.filter((fItem)=>{
      if(fItem.refNo == refNo){
        return fItem;
      }
    })
    return (
        <CheckBoxSingle
          key={item.refNo+"_singlecheck"}
          checked={
            isWO[0].isWOSelected
          }
          ref={(c) => {
            this.check = c;
          }}
          name="checkToSignoff"
          disabled={false}
          className="checkbox-default"
          onChecked={() => this.onCheckedForReassign(refNo)}
          style={{ marginTop: -7 }}
        />
      );
 
  }

  checkBoxRender(refNo) {
    const{data}=this.state;

    const anyFalseValue = data.some(item => item.isWOSelected === false);
    this.setState({
      isAllSelectedWO:!anyFalseValue
    });
    return (
      <CheckBoxSingle
        key={!anyFalseValue}
        checked={!anyFalseValue}
        name="checkToSignoff"
        disabled={this.state.disableSelectAll}
        className="checkbox-default"
        onChecked={() => this.onCheckedSelectAll(this.state.selectAllWO)}
        style={{ marginTop: -7 }}
      />
    );
  }

  customRenderWOID(item) {
    return (
      <span>
        <Link
          to={`/request-for-services/work-order/detail/${this.state.rfsId}/${item.refNo}`}
          onClick={this.onClickWOID(item)}
        >
          {item.refNo}
        </Link>
      </span>
    );
  }

  customRenderTrade(item) {
    if (item) {
      return <span>{item.trade ? item.trade.name : "-"}</span>;
    }
    return null;
  }

  customRenderAssigned(item) {
    if (item) {
      if (item.subcontractorProfile) {
        return <span>{item.subcontractorProfile.companyName}</span>;
      }
      if (item.assignedUser) {
        return <span>{item.assignedUser.displayName}</span>;
      }
      return "-";
    }
    return "-";
  }

  renderModal = (value) => {
    if (value == false) {
      this.fetchDetailRfs();
      this.setState({
        isDisplayReassignWOComponent: false,
        headerAction: {
          value: 0,
          text: "Bulk actions",
        },
      });
      const { column } = this.state;
      const newColumnState = [...column];
      newColumnState.shift();
      this.setState({
        column: newColumnState,
        selectAllWO: false,
      });
      this.props.dispatch({
        type: RFSActionType.UPDATED_FILTER_VALUE_FOR_WO,
        payload: [],
      });
      this.props.dispatch({
        type: RFSActionType.FILTER_WO,
        payload: [],
      });
      this.props.dispatch({
        type: RFSActionType.PREVIEW_WO_LIST,
        payload: [],
      });
    } else {
      this.setState({ isDisplayReassignWOComponent: true });
    }
  };

  toolTipDynamicMessage(message) {
    return (
      <Tooltip
        className="in tooltip-siteone"
        placement="top"
        id="tooltip"
        positionLeft={0}
        arrowOffsetLeft={0}
      >
        <span
          style={{
            wordBreak: "break-all",
            maxWidth: 200,
          }}
        >
          {message}
        </span>
      </Tooltip>
    );
  }

  customRenderSummary(item) {
    return <div style={{ whiteSpace: "break-spaces" }}>{item.title}</div>;
  }

  customRenderDescription(item) {
    return <div style={{ whiteSpace: "break-spaces" }}>{item.description}</div>;
  }

  customRenderStatus(item) {
    return (
      <span>
        {AppSettings.WO_STATUS_VALUE.find((x) => x.key === item.status).value}
      </span>
    );
  }

  customRenderAge(item) {
    return renderAgeOfWorkOrder(item);
  }

  customRenderWOT(item) {
    return (
      <div style={{ whiteSpace: "break-spaces" }}>
        {item.workOrderType && item.workOrderType.name}
      </div>
    );
  }
  customRenderItemtorepair(item) {
    if (item) {
      return (
        <span>{item.itemToRepair ? item.itemToRepair.description : "-"}</span>
      );
    }
    return null;
  }

  customRenderProblem(item) {
    if (item) {
      return <span>{item.problem ? item.problem.name : "-"}</span>;
    }
    return null;
  }

  onToggleReviewRFS = () => {
    this.setState({ isReviewRFS: !this.state.isReviewRFS }, () => {
      if (this.state.isReviewRFS) {
        this.fetchDetailRfs();
      }
    });
  };

  renderRFSInfo = () => {
    if (this.state.isReviewRFS) {
      return (
        <ReviewRFS
          rfsId={this.state.rfsId}
          RFSInformation={this.props.ManagerStore.RFSProfile}
          onToggleReviewRFS={this.onToggleReviewRFS}
        />
      );
    }

    return (
      <RFSInfo
        RFSInformation={this.props.ManagerStore.RFSProfile}
        onToggleReviewRFS={this.onToggleReviewRFS}
        location={this.props.location}
        history={this.props.history}
        mode="rfs"
        displayStatus={true}
        displayTab={true}
      />
    );
  };

  render() {
    const { ManagerStore } = this.props;
    const { isDisplayReassignWOComponent, data } = this.state;
    let selectedWOsForUpdate =data.filter(item => item.isWOSelected === true);
    
    if (
      ManagerStore &&
      ManagerStore.RFSProfile &&
      ManagerStore.RFSProfile.project
    ) {
      const { workOrders } = ManagerStore.RFSProfile;
      const totalRecord = workOrders ? workOrders.totalRecord : 0;

      const options = {
        defaultSortName: this.state.defaultSortName, // default sort column name
        defaultSortOrder: this.state.defaultSortOrder, // default sort order,
        sizePerPage: this.state.sizePerPage,
        totalRecord: totalRecord,
      };

      const lotName = ManagerStore.RFSProfile.lot
        ? ManagerStore.RFSProfile.lot.name
        : "";
      const lotId = ManagerStore.RFSProfile.lot
        ? ManagerStore.RFSProfile.lot.id
        : "";

      if(this.state.WoSelectedList.length >= 0){
        this.state.WoSelectedList.map((id)=> {
          WOSelectedInformation = this.props.ManagerStore.RFSProfile.workOrders.items.find((wo)=> wo.refNo == id)
        })
      }

      return (
        <div className="rfs-detail">
          <div className="page-title clearfix">
            <h2 className="pull-left">RFS #{this.state.rfsId}</h2>
            {AppSettings.clientTypeValue === "Builder" ? (
              <div className="text-right print-icon">
                <i
                  onClick={this.printPreviewRFS}
                  className="glyphicon glyphicon-print"
                />
              </div>
            ) : null}
          </div>
          {AppSettings.clientTypeValue === "Homeowner" ? (
            <ul className="breadcrumb">
              <li>
                <Link to={"/lots"}>Lots</Link>
              </li>
              <li>
                <Link to={`/lots/${lotId}`}>{lotName}</Link>
              </li>
              <li>
                <Link to={`/lots/${lotId}?active=request-for-service`}>
                  Requests for service
                </Link>
              </li>
              <li className="breadcrumb-siteone-li">RFS #{this.state.rfsId}</li>
            </ul>
          ) : (
            <ul className="breadcrumb">
              <li>
                <Link to={"/request-for-services"}>Requests for service</Link>
              </li>
              <li className="breadcrumb-siteone-li">RFS #{this.state.rfsId}</li>
            </ul>
          )}
          <div className="wrapper" style={{ minHeight: "auto" }}>
            {this.renderRFSInfo()}
          </div>

          <div className="page-title clearfix" style={{ marginTop: 40 }}>
            <h3 className="pull-left" style={{ margin: 0 }}>
              Work orders ({totalRecord})
            </h3>
            {AppSettings.clientTypeValue !== "Homeowner" &&
              ManagerStore.RFSProfile.status !== 4 && (
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "right"}}>
                  <button
                    className="btn btn-primary btn-info btn-siteone pull-right btn-icon"
                    onClick={this.onNewWorkOrder}
                    disabled={ManagerStore.RFSProfile.status === 3}
                    style={{marginTop:2}}
                  >
                    <span className="fa fa-plus icon" />
                    NEW
                  </button>
                  {ManagerStore.RFSProfile.requestType.type === 3 && (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={this.toolTipEOC()}
                      delayHide={10}
                      delayShow={500}
                    >
                      <button
                        style={{ width: 101, marginRight: 15 }}
                        className="btn btn-primary btn-siteone-orange pull-right btn-icon"
                        onClick={this.onEOCList}
                      >
                        ESF
                      </button>
                    </OverlayTrigger>
                  )}
                </div>
              )}
            {AppSettings.clientTypeValue === "Homeowner" &&
              ManagerStore.RFSProfile.requestType.type === 3 && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={this.toolTipEOC()}
                  delayHide={10}
                  delayShow={500}
                >
                  <button
                    style={{ width: 101, marginRight: 15 }}
                    className="btn btn-primary btn-siteone-orange pull-right btn-icon"
                    onClick={this.goToESFForm}
                  >
                    ESF
                  </button>
                </OverlayTrigger>
              )}
            {this.rfsRestrictModal()}
          </div>

          <TableList
            column={this.state.column}
            defaultParams={defaultParams}
            pagination={false}
            data={data}
            options={options}
            refreshPageList={this.refreshList.bind(this)}
            refreshList={this.refreshList.bind(this)}
            trClassName={row => checkIsOverdueWorkOrder(row)}
            // openAccordion={this.state.OpenAccordion}
            fetchDetailRfs={()=>{this.fetchDetailRfs()}}
            customTableHeader={
              <div className="table-header">
                <div className="row">
                  <div className="col-sm-12">
                    {AppSettings.clientTypeValue === "Homeowner" ?  <ul className="rfs-detail-table-header"><div className="manage-user-filter pull-right">
                        <button
                          id="popup-button"
                          onClick={this.onTogglePopupFilter}
                          className="btn btn-secondary fa fa-filter btn-icon"
                        />
                        {this.state.isShowPopup && (
                          <Popup
                            ref={(ref) => {
                              this.popup = ref;
                            }}
                            styles={{ width: 220, left: -60, zIndex: 99999 }}
                          >
                            {AppSettings.WO_STATUS_VALUE.map((item) => {
                              return (
                                <CheckBox
                                  checked={this.state.checkedValues.includes(
                                    item.key
                                  )}
                                  name="status"
                                  className="punch-item__status"
                                  value={item.key}
                                  key={item.key}
                                  label={item.value}
                                  handleChange={this.handleChange}
                                />
                              );
                            })}
                          </Popup>
                        )}
                      </div></ul> :
                    <ul className="rfs-detail-table-header">
                      <li>
                        <Dropdown
                          onChange={this.onChangeHeaderAction}
                          filter={true}
                          className="filestring-dropdown filter-dropdown"
                          options={this.state.headerOptions}
                          optionLabel="text"
                          value={this.state.headerAction}
                          style={{ width: 200, margin: 0 }}
                        />
                      </li>
                      {this.state.headerAction.value === 1 &&
                        Object.keys(this.state.refNoCheckList).length === 0 && (
                          <OverlayTrigger
                            trigger="click"
                            placement="right"
                            overlay={this.popoverRight()}
                          >
                            <button className="btn btn-primary btn-info btn-siteone btn-icon">
                              Go
                            </button>
                          </OverlayTrigger>
                        )}
                      {this.state.headerAction.value === 1 &&
                        Object.keys(this.state.refNoCheckList).length !== 0 && (
                          <button
                            className="btn btn-primary btn-info btn-siteone btn-icon"
                            onClick={this.onClickGoSignoffMultiplePopup}
                          >
                            Go
                          </button>
                        )}
                      {this.state.headerAction.value === 1 &&
                        this.state.isDisplaySignoffMultiplePopup && (
                          <SignoffMultiplePopup
                            isValid={
                              Object.keys(this.state.refNoCheckList).length !==
                              0
                            }
                            onSaveSignoffPopup={this.onSaveSignoffMultiple}
                            onCancelSignoffPopup={
                              this.onClickGoSignoffMultiplePopup
                            }
                          />
                        )}
                    {/* Reassign WO Go buttons */}
                        {/* if no WO is selected or WO list is empty*/}
                        {this.state.headerAction.value === 2 &&
                        selectedWOsForUpdate.length === 0 && (
                          <OverlayTrigger
                            trigger="click"
                            placement="right"
                            overlay={this.popoverRight()}
                          >
                            <button className="btn btn-primary btn-info btn-siteone btn-icon" onClick={()=> {console.log("go-1", this.state.refNoCheckListForReassign)}}>
                              Go
                            </button>
                          </OverlayTrigger>
                        )}
                      {/* if WO is selected */}
                      {this.state.headerAction.value === 2 &&
                        selectedWOsForUpdate.length !== 0 && (
                          <button
                            className="btn btn-primary btn-info btn-siteone btn-icon"
                            onClick={() => {
                              this.setState({
                                isDisplayReassignWOComponent: true,
                              });
                            }}
                          >
                            Go
                          </button>
                        )}
                       {/* reassign modal component */}
                      {this.state.isDisplayReassignWOComponent === true ? (
                        <ReassignWO
                          isDisplayReassignWOComponent={
                            isDisplayReassignWOComponent
                          }
                          data={selectedWOsForUpdate}
                          dispatch={this.props.dispatch}
                          onRenderModal={(value) => {
                            this.renderModal(value);
                          }}
                          rfsRefNo={this.state.rfsId}
                        />
                      ) : (
                        ""
                      )}
                    {this.state.headerAction.value === 3 &&
                      Object.keys(this.state.refNoSendCheckList).length !== 0 && (
                        <button
                          className='btn btn-primary btn-info btn-siteone btn-icon'
                          onClick={this.onTogglePopup('open')}
                          style={{ marginLeft: 20 }}
                        >
                          Go
                        </button>
                      )}
                    {this.state.headerAction.value === 3 &&
                      this.state.isDisplaySendMultiplePopup && (
                        <OpenAwaitPopup
                          isOpen={true}
                          woInformation={this.state.WoSelectedList.length > 0 ? WOSelectedInformation: null}
                          rfsInformation={ManagerStore.RFSProfile}
                          onFetchItemRepair={data => this.fetchItemRepair(data)}
                          onFetchProblem={data => this.fetchProblem(data)}
                          onFetchSubcontractor={data => this.fetchSubcontractor(data)}
                          onFetchTrade={this.fetchTrade}
                          onFetchUser={this.fetchUser}
                          onFetchWOT={this.onFetchWorkOrderType}
                          userList={this.props.UserList}
                          itemRepairList={this.props.ItemRepairList}
                          problemList={this.props.ProblemList}
                          subcontractorList={this.props.SubcontractorList}
                          tradeList={this.props.TradeList}
                          workOrderTypeList={this.props.WorkOrderTypeList}
                          requireFormField={this.state.requireFormField}
                          onCancelPopup={this.onClickpopupSendMultiple}
                          BulkSendWORFSpage={true}
                          onSubmit={(type, params) =>
                            this.onClickSubmitOpenPend(type, params)
                          }
                        />
                      )}
                       {this.state.headerAction.value === 3 &&
                        this.state.ConfirmSendMultiple && (
                          <SendMultipleWorkOrderPopup
                            onSend={this.onClickSubmitOpenPend}
                            onCancel={this.onClickGoSendMultiplePopup}
                          />
                        )}
                  {this.state.headerAction.value === 3 &&
                    Object.keys(this.state.refNoSendCheckList).length === 0 && (
                      <OverlayTrigger
                        trigger='click'
                        rootClose
                        placement={this.state.isMobile ? 'bottom' : 'right'}
                        overlay={this.popoverRight()}
                      >
                        <button
                          className='btn btn-primary btn-info btn-siteone btn-icon'
                          style={{ marginLeft: 20 }}
                        >
                          Go
                        </button>
                      </OverlayTrigger>
                    )}
                      <div className="manage-user-filter pull-right">
                        <button
                          id="popup-button"
                          onClick={this.onTogglePopupFilter}
                          className="btn btn-secondary fa fa-filter btn-icon"
                        />
                        {this.state.isShowPopup && (
                          <Popup
                            ref={(ref) => {
                              this.popup = ref;
                            }}
                            styles={{ width: 220, left: -60, zIndex: 99999 }}
                          >
                            {AppSettings.WO_STATUS_VALUE.map((item) => {
                              return (
                                <CheckBox
                                  checked={this.state.checkedValues.includes(
                                    item.key
                                  )}
                                  name="status"
                                  className="punch-item__status"
                                  value={item.key}
                                  key={item.key}
                                  label={item.value}
                                  handleChange={this.handleChange}
                                />
                              );
                            })}
                          </Popup>
                        )}
                      </div>
                    </ul>
                    }
                  </div>
                </div>
              </div>
              
            }
            // showButtonMenu={true}
            //onContextMenu={this.onContextMenu.bind(this)}
          />
          <iframe
            id="ifmcontentstoprint"
            style={{ height: 0, border: "none" }}
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    UserProfile: state.UserStore,
    ManagerStore: state.RFSStore,
    WorkOrders: state.WorkOrderReducer,
    LotStore: state.LotStore,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    WorkOrderTypeList: state.WorkOrderTypesStore.WOTList,
    UserList: state.ProjectStore.UserSelectList,
    TradeList: state.LotStore.TradeList,
    ItemRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    toggleModal: bindActionCreators(componentActions.toggleModal, dispatch),
    dispatch
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RFSDetail);



// WEBPACK FOOTER //
// ./src/Request-Services/Containers/RFSDetail.js